import {validations} from "./Validations";
import {MAC_ES_OPTIONS, MAC_ES_LABELS} from "./FormConfig.tsx";
import {Forms} from "@types/FormTypes";

/** Constants for API configuration */
const API_BASE_URL = `${window.location.origin}/wp-json/simulators/v1/mac-es`;
const PROCESS_TYPE = 4;
const OPERATION_TYPE = 2;

/**
 * Simulator custom URL - Check if exists some custom URL for this block
 * [==START==]
 */
let MIDDLEWARE_API_URL = API_BASE_URL;
const rootElement = document.querySelector('[data-block="tool-block"]') as HTMLElement | null;
if ( rootElement !== null ) {
  const NEW_URL = rootElement.getAttribute('data-tool-managment');
  if ( NEW_URL !== null && NEW_URL !== '' ) {
    MIDDLEWARE_API_URL = NEW_URL;
  }
}
/* [==END==] */

/**
 * Form configuration.
 *
 * Fields are flat (propertyCondition, not property.condition; customerAge,
 * not customers[0].age) - the PHP service (MacEsService::prepareData)
 * reshapes them into the nested payload the external API expects, and
 * fixes `country` to "ES" itself.
 */
export const forms: Forms = {
    mac_es: {
        validation: validations.mac_es,
        api: {
            url: MIDDLEWARE_API_URL,
            processType: PROCESS_TYPE,
            operationType: OPERATION_TYPE,
        },
        fields: [
            {
                type: "title",
                label: MAC_ES_LABELS.titleProperty,
            },
            {
                type: "group",
                group_fields: [
                    {
                        type: "heading",
                        label: MAC_ES_LABELS.monthlyNetIncome,
                    },
                    {
                        type: "range",
                        name: "monthlyNetIncome",
                        defaultValue: 4500,
                        options: [
                            {value: 0, label: "0 €"},
                            {value: 20000, label: "20.000 €"},
                            {value: 100, label: "€"},
                        ],
                    },
                ],
            },
            {
                type: "group",
                group_fields: [
                    {
                        type: "heading",
                        label: MAC_ES_LABELS.monthlyLoanExpenses,
                    },
                    {
                        type: "range",
                        name: "monthlyLoanExpenses",
                        defaultValue: 700,
                        options: [
                            {value: 0, label: "0 €"},
                            {value: 10000, label: "10.000 €"},
                            {value: 100, label: "€"},
                        ],
                    },
                ],
            },
            {
                type: "group",
                group_fields: [
                    {
                        type: "heading",
                        label: MAC_ES_LABELS.equityDownAmount,
                    },
                    {
                        type: "range",
                        name: "equityDownAmount",
                        defaultValue: 60000,
                        options: [
                            {value: 10000, label: "10.000 €"},
                            {value: 1000000, label: "1.000.000 €"},
                            {value: 100, label: "€"},
                        ],
                    },
                ],
            },
            /*{
                type: "group",
                group_fields: [
                    {
                        type: "heading",
                        label: MAC_ES_LABELS.customerAge,
                    },
                    {
                        type: "number",
                        name: "customerAge",
                        placeholder: "35",
                    },
                ],
            },*/
            {
                type: "group",
                group_fields: [
                    {
                        type: "heading",
                        label: MAC_ES_LABELS.loanTermInYears,
                    },
                    {
                        type: "range",
                        name: "loanTermInYears",
                        defaultValue: 30,
                        options: [
                            {value: 1, label: "1"},
                            {value: 40, label: "40"},
                            {value: 1, label: MAC_ES_LABELS.years},
                        ],
                    },
                ],
            },
            {
                type: "group",
                group_fields: [
                    {
                        type: "heading",
                        label: MAC_ES_LABELS.rateType,
                    },
                    {
                        type: "select",
                        options: MAC_ES_OPTIONS.rateType,
                        name: "rateType",
                        defaultValue: "FIXED",
                    },
                ],
            },
            {
                type: "group",
                group_fields: [
                    {
                        type: "heading",
                        label: MAC_ES_LABELS.region,
                    },
                    {
                        type: "select",
                        options: MAC_ES_OPTIONS.region,
                        name: "region",
                        defaultValue: "MADRID",
                    },
                ],
            },
            {
                type: "group",
                group_fields: [
                    {
                        type: "heading",
                        label: MAC_ES_LABELS.propertyCondition,
                    },
                    {
                        type: "radio",
                        options: MAC_ES_OPTIONS.propertyCondition,
                        name: "propertyCondition",
                        className: "condition-radio",
                        defaultValue: "USADA",
                    },
                ],
            },
        ],
    },
};
